import type { StoryScript } from '../types';

/** Historie med navn, køretøj og dyr. Udnytter både pronomen og to x bestemt form. */
export const PAA_TUR_I_SKOVEN: StoryScript = {
  id: 'paa-tur-i-skoven',
  title: 'På tur i skoven',
  storyLevel: 1,
  defaultBlankLength: 12,
  blanks: {
    navn: {
      maxLength: 10,
      hint: 'fx emil eller sofie',
    },
    koretoj: {
      maxLength: 14,
      hint: 'fx bil, traktor eller tog',
      definiteOnReuse: true,
    },
    dyr: {
      maxLength: 12,
      hint: 'fx hund, bjørn eller frø',
      definiteOnReuse: true,
    },
  },
  beats: [
    {
      id: 'b1',
      template:
        '{{navn:10}} kørte en tur i skoven i sin {{koretoj:14}}',
    },
    {
      id: 'b2',
      template: 'pludselig så {{pron:navn}} {{art:dyr}} {{dyr:12}} bag en busk',
    },
    {
      id: 'b3',
      template: 'hop op i {{koretoj}} råbte {{navn}} højt',
    },
    {
      id: 'b4',
      template: 'så kørte {{navn}} og {{dyr}}\nglade hjem',
    },
  ],
};
